

import { signalGenericRequest } from "../../../api/signalApi";
import { ACCOUNT_ENTRIES_COMPANIES, ACCOUNT_ENTRIES_GET_ACTIVE_GROUP, ACCOUNT_ENTRIES_GET_DOCUMENT_DATA, ACCOUNT_ENTRIES_GET_DOCUMENT_RESOURCES, ACCOUNT_ENTRIES_GET_GROUP_DETAILS, ACCOUNT_ENTRIES_GROUP_DELETE, ACCOUNT_ENTRIES_GROUP_SAVE, ACCOUNT_ENTRIES_GROUP_UPDATE, ACCOUNT_ENTRIES_LIST_GROUPS, ACCOUNT_ENTRIES_PERIODS, ACCOUNT_ENTRIES_SCHEME, ACCOUNT_ENTRIES_SET_DEFAULT_GROUP, ACCOUNT_ENTRIES_SET_NEW_GROUP, ACCOUNT_ENTRIES_VFLEX_CONFIGURATION, VFLEX_SAVE_FIELD_POSITION, VFLEX_SAVE_FIELD_WIDTH, VFLEX_SAVE_FIELDS_CONFIG, VFLEX_SAVE_FIELDS_GROUPING } from "../../../constants/signalRequestConsts";
import { Scenarios } from "../../../constants/scenarios";
import { store } from "../../store";


export const getCompanies = async (folder: string) => {
    const {sessionData} = store.getState().auth;
	// const headers = {
	// 	ModuleId: process.env.REACT_APP_MODULE_ID,
	// 	Token: authCompanySelectedState.companyselected?.Token,

	// }
    await signalGenericRequest(
        ACCOUNT_ENTRIES_COMPANIES,
        `dbo.S10_14_Empresa_ListarPorUsuario '${sessionData?.UserName}','14',${folder}`
    )
}



export const getActiveGroup = async (scenario: Scenarios) => {
    const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        ACCOUNT_ENTRIES_GET_ACTIVE_GROUP,
        `dbo.S10_00GRP_ObtenerGrupoActivo '${sessionData?.UserName}','${scenario}'`,
        scenario
    )
}

export const listGroups = async (scenario: Scenarios) => {
    const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        ACCOUNT_ENTRIES_LIST_GROUPS,
        `dbo.S10_00GRP_ObtenerGrupos '${sessionData?.UserName}','${scenario}'`,
        scenario
    )
}

export const getGroupDetails = async (correlarive: number, scenario: Scenarios) => {
    const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        ACCOUNT_ENTRIES_GET_GROUP_DETAILS,
        `dbo.S10_00GRP_ObtenerGruposDetalle '${sessionData?.UserName}','${scenario}', ${correlarive}`,
        scenario
    )
}

export const setDefaultGroup = async (correlarive: number | null, scenario: Scenarios) => {
    const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        ACCOUNT_ENTRIES_SET_DEFAULT_GROUP,
        `dbo.S10_00GRP_CopiarGrupo '${sessionData?.UserName}','${scenario}','${sessionData?.UserName}',${correlarive}`,
        scenario
    )
}

export const setNewGroup = async (description: string, scenario: Scenarios) => {
    const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        ACCOUNT_ENTRIES_SET_NEW_GROUP,
        `dbo.S10_00GRP_AdicionarGrupo '${sessionData?.UserName}','${scenario}',null,'${description}'`,
        scenario
    )
}

export const updateGroup = async ({jsonFields, correlative}: any, scenario: Scenarios) => {
    const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        ACCOUNT_ENTRIES_GROUP_UPDATE,
        `dbo.S10_00_Grupo_Modificar '${sessionData?.UserName}','${scenario}',${correlative},'${jsonFields}'`,
        scenario
    )
}

export const createGroupWithFields = async ({jsonFields, name}: any, scenario: Scenarios) => {
    const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        ACCOUNT_ENTRIES_GROUP_SAVE,
        `dbo.S10_00_Grupo_Adicionar '${sessionData?.UserName}','${scenario}',null,'${name}','${jsonFields}'`,
        scenario
    )
}

export const deleteGroup = async (correlative: number, scenario: Scenarios) => {
    const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        ACCOUNT_ENTRIES_GROUP_DELETE,
        `dbo.S10_00_Grupo_Eliminar '${sessionData?.UserName}','${scenario}',${correlative}`,
        scenario
    )
}






export const getSchemes = async (companyRuc: string) => {
    await signalGenericRequest(
        ACCOUNT_ENTRIES_SCHEME,
        `dbo.S10_14_Esquema_ListarPorEmpresa '${companyRuc}'`
    )
}

export const getPeriods = async (companyRuc: string) => {
    await signalGenericRequest(
        ACCOUNT_ENTRIES_PERIODS,
        `dbo.S10_14_Periodo_ListarPorEmpresa '${companyRuc}'`
    )
}


export const getConfiguration = async (scenario: Scenarios, scenarioSufix: string = '') => {
    const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        ACCOUNT_ENTRIES_VFLEX_CONFIGURATION,
        `dbo.sp_ConfiguracionVsFlex '${sessionData?.UserName}', '${scenario}${scenarioSufix}', 0, 0, ''`,
        scenario
    )
}

export const startMigrationProccess = async () => {
    await signalGenericRequest(
        "contabilidadERPResult",
        `com: datContabilidad`
    )
}

export const vflexSaveFieldPosition = async (fieldName: string, fieldPosition: number, scenario: Scenarios) => {
    const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        VFLEX_SAVE_FIELD_POSITION,
        `dbo.S10_00_ConfiguracionVsFlex_GrabarPosicion '${sessionData?.UserName}', '${scenario}', '${fieldName}', ${fieldPosition}`,
        scenario
    )
}

export const vflexSaveFieldWidth = async (fieldName: string, fieldWidth: number, scenario: Scenarios) => {
    const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        VFLEX_SAVE_FIELD_WIDTH,
        `dbo.S10_00_ConfiguracionVsFlex_GrabarCampo '${sessionData?.UserName}', '${scenario}', '${fieldName}', ${fieldWidth}`,
        scenario
    )
}

/*
[
	{
		"Campo": "Procedencia",
		"Posicion": 0,
		"Visible": true,
		"Sumar": false
	},
]
*/
export const vflexSaveFieldsConfig = async (jsonConfig: string, scenario: Scenarios) => {
    const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        VFLEX_SAVE_FIELDS_CONFIG,
        `dbo.S10_00_ConfiguracionVsFlex_GrabarMasivo '${sessionData?.UserName}', '${scenario}', '${jsonConfig}'`,
        scenario
    )
}

/*
[
	{
		"Posicion": 0,
		"Cabecera": "Procedencia",
		"Campo": "Procedencia"
	},
	{
		"Posicion": 1,
		"Cabecera": "N° Asiento",
		"Campo": "Voucher"
	}
]
*/
export const vflexSaveFieldsGrouping = async (jsonGrouping: string, scenario: Scenarios) => {
    const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        VFLEX_SAVE_FIELDS_GROUPING,
        `dbo.S10_00_Grupo_GrabarMasivo '${sessionData?.UserName}', '${scenario}', 0, '${jsonGrouping}'`,
        scenario
    )
}

export const getDocumentData = async (documentNumber: string) => {
    // const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        ACCOUNT_ENTRIES_GET_DOCUMENT_DATA,
        `dbo.S10_00_RDocumento_Consultar '${documentNumber}'`,
    )
}

/*
CREATE  PROCEDURE [dbo].[sp_00ObtenerRecursos]
 	@NroD  					UniqueIdentifier,
	@CodTipoDocumento		Varchar(3) = '',
	@CodTipoDocumentoSunat	Varchar(2) ,
	@ConTipo				Bit = 1
	
	Donde:
	@CodTipoDocumento lo sacas del 1er SP
	@CodTipoDocumentoSunat lo sacas del 1er SP
	@ConTipo siempre le pasas 1
*/

export const getDocumentResources = async (nroD: string, codDocumentType: string, codDocumentTypeSunat: string) => {
    // const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        ACCOUNT_ENTRIES_GET_DOCUMENT_RESOURCES,
        `dbo.sp_00ObtenerRecursos '${nroD}', '${codDocumentType}', '${codDocumentTypeSunat}', 1`,
    )
}
